import { Filter } from '@anytag/shared-molecules';
import { useInfluencerPackagesContext } from '../InfluencerPackagesContext';
import { BasicFilter } from './BasicFilter';

export const InfluencerPackagesFilter = () => {
  const { filter, setFilter, isEngagementPage } = useInfluencerPackagesContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} />
    </Filter.Provider>
  );
};
